import Landingheader from "./Landingheader";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Footer from '../Footer';
import ServiceCard from "./ServiceCard";
import Services from "./Services";
import ScrollToTop from "../ScrollToTop";
const Landingpage = () => {
     //check if user authonticated
    const Navigate = useNavigate();
/* useEffect(() => {
    const Auth_token = sessionStorage.getItem('authToken');
    if(!Auth_token){
        Navigate('/login');
    }
    });
    */
    return (  
        <div className=" bg-gray-50">
            <Landingheader />
            <Services />
            <Footer />
            <ScrollToTop />
        </div>
    );
}
 
export default Landingpage;